// Crossover Solo — panel-orientation walkthrough.
//
// Demonstrate phase (T3-IDAC). The trainee walks through PROGRAM,
// PRESET, AUTO TRANS, and CUT in sequence. Each predicate-bearing
// step auto-advances when the trainee performs the matching action;
// pure look-and-read steps advance on Next. Steps without a
// predicate are deliberate — they ask the trainee to *look*, not act.

import type { CrossoverSoloAction } from "../../crossover-solo-actions";
import type { WalkthroughStep } from "../../../help/help-types";

export const CROSSOVER_SOLO_PANEL_ORIENTATION: WalkthroughStep[] = [
  {
    id: "intro-buses",
    body:
      "Look at the panel. The two horizontal rows of large white buttons are the buses you'll work with most. The upper row is PROGRAM (red label) — it controls what's currently going out to the audience. The lower row is PRESET (green label) — what you're armed to take next. Notice CAM 1 is lit red on PROGRAM right now: that's what's on air.",
  },
  {
    id: "arm-preset",
    body:
      "Click CAM 2 on the green PRESET row. It will light green. That doesn't change what's on air — it only arms CAM 2 as the next take.",
    matches: (a: CrossoverSoloAction) => a.kind === "arm" && a.target === "cam2",
  },
  {
    id: "auto-trans",
    body:
      "Now press the AUTO TRANS button on the right side of the panel (or hit the Space key). The panel will dissolve from CAM 1 to CAM 2 over a short transition. Watch the red label move with the take.",
    matches: (a: CrossoverSoloAction) => a.kind === "auto",
  },
  {
    id: "arm-back",
    body:
      "Arm CAM 3 on the green PRESET row.",
    matches: (a: CrossoverSoloAction) => a.kind === "arm" && a.target === "cam3",
  },
  {
    id: "cut",
    body:
      "Press CUT (or Enter) for an instant take to CAM 3 — no dissolve, the cut is hard. AUTO TRANS dissolves; CUT switches instantly. Both move PRESET onto PROGRAM.",
    matches: (a: CrossoverSoloAction) => a.kind === "cut",
  },
  {
    id: "ftb",
    body:
      "Last control to know: FTB (Fade to Black) on the far right. You'll use it at the end of a session or in an emergency. Press it once now. The button latches red while black is on air.",
    matches: (a: CrossoverSoloAction) => a.kind === "ftb",
  },
];
